import React, { useEffect, useState, useRef, useMemo } from "react";
import { Context, Hooks, Util, Request } from "@xt/xtbase";
const { XtContext, XtAuth } = Context;
const { useTranslation } = Hooks;
import cx from "classnames";
import styles from "./index.module.less";
import img_beginner from "./beginner.svg";
import img_tier from "./tier.svg";
import img_promotion from "./promotion.svg";
import { useStore } from "@/models";
import { observer } from "mobx-react-lite";

export default observer(({ data }) => {
  const t = useTranslation();
  const { finance } = useStore();

  const keyLabelObj = useMemo(() => {
    return {
      beginner: t("finance.tagBeginner"),
      tier: t("finance.tagTier"),
      promotion: t("finance.tagPromotion"),
    };
  }, []);
  const keyImgObj = useMemo(() => {
    return {
      beginner: img_beginner,
      tier: img_tier,
      promotion: img_promotion,
    };
  }, []);

  //将data转化为组件selfData
  const selfData = useMemo(() => {
    let type;
    if (data.noviceExclusive) {
      type = "beginner";
    } else if (data.productType === "RUSH") {
      type = "promotion";
    } else if (data.profitType === "GRADING") {
      type = "tier";
    } else {
      return;
    }

    const convertData = {
      type, //beginner tier promotion
      img: keyImgObj[type],
      label: keyLabelObj[type],
    };

    return convertData;
  }, [data]);

  if (!selfData) return <></>;

  return (
    <div className={cx(styles.main, styles[selfData.type])}>
      <img src={selfData.img} />
      <div>{selfData.label}</div>
    </div>
  );
});
